import { useParams } from 'react-router-dom'

import { can } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'
import { DocumentsList } from '@/features/docs/DocumentsList'
import { SkeletonRows } from '@/shared/components/data'
import { useT } from '@/shared/i18n'

import { useProject } from '../api'

/**
 * Tab "Documentos" del proyecto.
 *
 * Es el MISMO módulo que el de la empresa, filtrado por proyecto: markdown con
 * versionado y links a Drive o Figma. Un segundo listado propio sería un
 * segundo lugar donde se pierden las cosas.
 */
export function ProjectDocumentsTab() {
  const { projectId = '' } = useParams()
  const t = useT()
  const { me } = useSession()
  const project = useProject(projectId)

  if (!project.data) return <SkeletonRows rows={4} withSpine={false} />

  const companyId = project.data.company.id

  return (
    <DocumentsList
      companyId={companyId}
      projectId={projectId}
      filters={{ project_id: projectId }}
      canWrite={can(me, 'document:write', { companyId })}
      emptyTitle={t('projects.documents.emptyTitle')}
      emptyDescription={t('projects.documents.emptyDescription')}
    />
  )
}
